import User from '../entities/User';

export function authHeader() {
    // return authorization header with jwt token
    let user = User.current();

    if (user && user.token) {
        return { 'Authorization': 'Bearer ' + user.token };
    } else {
        return {};
    }
}


// WEBPACK FOOTER //
// ./src/helpers/auth-header.js